import { InjectionKey } from 'vue';
import { AllocationGroupType } from './AllocationSelectionPanel.types';

// This follows the recommendation for typing Provide/Inject: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
export const allocationGroupKey = Symbol('allocationGroupKey') as InjectionKey<{
    type: AllocationGroupType;
}>;
